module.exports = __webpack_public_path__ + "static/media/GothamBookRegular.a563635d.otf";